import {required,numeric} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPerfTablo = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPerfTabloData:{
            Id: "",
            Adi: "",
            Hedefi: "",
            PerformansHedefi: "",
            Notu: "",
            Aktif: true,
            SiraNo: 0,
            AmacId: 0,
            BirimId: null,
            DonemId: 0,
            HedefGirilsin: false,
            HarcamaGirisiPasif: false,
            Programad: "",
            Programhedef: "",
            Deleted: false,
          },
        FormDataType:{ 
        
          SiraNo:{FieldName:"SiraNo",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.SiraNo'),FieldType:"number"},
          Adi:{FieldName:"Adi",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.Adi'),FieldType:"text"},
          AmacId:{FieldName:"AmacId",Field:"combobox",FieldTitle:this.$t('StrPerfTablo.AddEdit.AmacId'),ComboDataArray:[]},
          DonemId:{FieldName:"DonemId",Field:"combobox",FieldTitle:this.$t('StrPerfTablo.AddEdit.DonemId'),ComboDataArray:[]},
          BirimId:{FieldName:"BirimId",Field:"combobox",FieldTitle:this.$t('StrPerfTablo.AddEdit.BirimId'),ComboDataArray:[]},
          Hedefi:{FieldName:"Hedefi",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.Hedefi'),FieldType:"text"},
          PerformansHedefi:{FieldName:"PerformansHedefi",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.PerformansHedefi'),FieldType:"text"},
          Notu:{FieldName:"Notu",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.Notu'),FieldType:"text"},
          Aktif:{FieldName:"Aktif",Field:"checkbox",FieldTitle:this.$t('StrPerfTablo.AddEdit.Aktif')},  
          HedefGirilsin:{FieldName:"HedefGirilsin",Field:"checkbox",FieldTitle:this.$t('StrPerfTablo.AddEdit.HedefGirilsin')},  
          HarcamaGirisiPasif:{FieldName:"HarcamaGirisiPasif",Field:"checkbox",FieldTitle:this.$t('StrPerfTablo.AddEdit.HarcamaGirisiPasif')},  
          Programad:{FieldName:"Programad",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.Programad'),FieldType:"text"},
          Programhedef:{FieldName:"Programhedef",Field:"input",FieldTitle:this.$t('StrPerfTablo.AddEdit.Programhedef'),FieldType:"text"},
          
        }   
      }
    },
    validations:{ 
        FormData: {
            SiraNo: { required, numeric },
            Adi: { required },
            Hedefi: { required },
            PerformansHedefi: { required },
            Notu: { required },
            AmacId: { required },
            BirimId: { required },
            DonemId: { required },
            Aktif: {},
            HedefGirilsin: {},
            HarcamaGirisiPasif: {},
            Programad: {},
            Programhedef: {},
        } 
    },


    created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }


          let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 
                        Tip.push(res.Data[i].Id);       
                    }            
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                   
                    this.FormDataType.DonemId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
                  
                }
              });
         
            });


        
          this.ActionsGet({"Service":"OBirim", "Page":Page}).then((res) => {

            for(var i=0; i<res.Data.length; i++)
            {
              this.FormDataType.BirimId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].BirimAdi})        
            } 
          }); 
    
      
    }

}
export default StrPerfTablo